import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Utensils } from "lucide-react";
import { Link } from "react-router-dom";

export default function ClientNutritionPage() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/me/meal-plan").then(({ data }) => setData(data)); }, []);
    if (!data) return <div className="p-8 text-[var(--text-muted)]">Loading…</div>;

    const plan = data.meal_plan;

    return (
        <div className="p-8 space-y-6" data-testid="client-nutrition-page">
            <div>
                <p className="label-tiny mb-2">/ Fuel</p>
                <h1 className="font-serif text-6xl">Nutrition</h1>
            </div>

            {!plan ? (
                <div className="border border-dashed border-[var(--border-bright)] p-10 text-center">
                    <Utensils size={32} className="text-[var(--gold)] mx-auto mb-4" />
                    <p className="font-serif text-2xl mb-2">No meal plan assigned yet.</p>
                    <p className="text-sm text-[var(--text-muted)]">Your coach will assign one — <Link to="/client/messages" className="text-[var(--gold)]">message them</Link> if you're ready.</p>
                </div>
            ) : (
                <>
                    <div className="border border-[var(--gold-deep)] bg-[var(--surface)] p-6 relative overflow-hidden" data-testid="meal-plan-card">
                        <div className="absolute inset-0 bg-stripes opacity-15 pointer-events-none" />
                        <div className="relative">
                            <h2 className="font-serif text-4xl mb-2">{plan.name}</h2>
                            {plan.description && <p className="text-sm text-[var(--text-muted)] mb-5">{plan.description}</p>}
                            <div className="grid grid-cols-4 gap-px bg-[var(--border)]">
                                <div className="bg-[var(--surface)] p-4 text-center"><p className="label-tiny">KCAL</p><p className="font-display text-4xl mt-1">{plan.daily_calories}</p></div>
                                <div className="bg-[var(--surface)] p-4 text-center"><p className="label-tiny">PROTEIN</p><p className="font-display text-4xl mt-1 text-[var(--gold-bright)]">{plan.protein_g}g</p></div>
                                <div className="bg-[var(--surface)] p-4 text-center"><p className="label-tiny">CARBS</p><p className="font-display text-4xl mt-1">{plan.carbs_g}g</p></div>
                                <div className="bg-[var(--surface)] p-4 text-center"><p className="label-tiny">FAT</p><p className="font-display text-4xl mt-1">{plan.fat_g}g</p></div>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-4">
                        {(plan.meals || []).map((m, i) => (
                            <div key={i} className="border border-[var(--border)] bg-[var(--surface)]" data-testid={`cl-meal-${i}`}>
                                <div className="flex items-center justify-between p-4 border-b border-[var(--border)]">
                                    <div className="flex items-center gap-3">
                                        <Utensils size={16} className="text-[var(--gold)]" />
                                        <h3 className="font-serif text-2xl">{m.name}</h3>
                                    </div>
                                    {m.notes && <p className="text-xs text-[var(--text-muted)] italic">{m.notes}</p>}
                                </div>
                                <ul className="p-5 space-y-2">
                                    {(m.items || []).length === 0 && <li className="text-sm text-[var(--text-muted)]">— nothing set —</li>}
                                    {(m.items || []).map((item, j) => (
                                        <li key={j} className="flex items-start gap-3">
                                            <span className="text-[var(--gold)] font-mono text-xs mt-1">·</span>
                                            <span className="text-sm">{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}
